import React from 'react';
import classnames from 'classnames';
import styles from './FileInput.module.scss';
import { Button } from 'react-bootstrap';
import { Control, Controller, UseFormResetField } from 'react-hook-form';
import fileIcon from 'v2/icons/file2.svg';
import { unit } from 'mathjs';

interface FileInputProps {
  file: File | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resetField: UseFormResetField<any>;
  disabled?: boolean;
  accept?: string;
}

const FileInput = ({
  file,
  control,
  resetField,
  disabled,
  accept,
}: FileInputProps) => {
  return (
    <>
      {!file ? (
        <label
          className={classnames(styles.btnSecondary__label)}
          htmlFor="file"
        >
          CHOOSE FILE
        </label>
      ) : (
        <div className={classnames(styles.fileInfoContainer)}>
          <img
            className={classnames(styles.fileIcon)}
            src={fileIcon}
            alt="file icon"
          />
          <p className={classnames(styles.filename)}>{file.name}</p>
          <Button
            variant="link"
            onClick={() => resetField('file')}
            className={classnames(styles.actionBtn)}
            disabled={disabled}
          >
            Remove File
          </Button>
        </div>
      )}

      <Controller
        name="file"
        control={control}
        rules={{
          required: true,
          validate: {
            limit_bytes_size: (file) =>
              file.size < unit('25 MB').toNumber('bytes'),
          },
        }}
        render={({ field: { value: _, onChange, ...field } }) => {
          return (
            <input
              {...field}
              id="file"
              type="file"
              accept={accept}
              hidden
              onChange={(event) => {
                onChange(event.target.files?.[0]);
                event.target.value = '';
              }}
            />
          );
        }}
      />
    </>
  );
};

export default FileInput;
